"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _analyticsDataContext = require("./analyticsDataContext");
Object.keys(_analyticsDataContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _analyticsDataContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _analyticsDataContext[key];
    }
  });
});
var _dialogModeContext = require("./dialogModeContext");
Object.keys(_dialogModeContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dialogModeContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogModeContext[key];
    }
  });
});
var _productContext = require("./productContext");
Object.keys(_productContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productContext[key];
    }
  });
});
var _productsContext = require("./productsContext");
Object.keys(_productsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productsContext[key];
    }
  });
});
var _replaceSubscriptionDataContext = require("./replaceSubscriptionDataContext");
Object.keys(_replaceSubscriptionDataContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _replaceSubscriptionDataContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _replaceSubscriptionDataContext[key];
    }
  });
});
var _sharedConfigurationContext = require("./sharedConfigurationContext");
Object.keys(_sharedConfigurationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sharedConfigurationContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sharedConfigurationContext[key];
    }
  });
});
